<script>
  export let placeholder = "", value = "", type = 'text', dStyle='space-y-4 md:space-y-6'
  export let readOnly = false, required = true
  export let id, slug, options = [], callback = false
</script>
<div class={dStyle}>
  <fieldset>
    <label for={id} class="text-sm text-gray-100 font-body mb-2">{slug}</label>
    {#if type === 'select'}
    <select id={id} class="font-body bg-shearling hover:border-deep_juniper rounded-none relative block w-full px-3 py-2 border-shearling border border-solid placeholder-gray-400 text-obsidian focus:outline-none focus:ring-deep_juniper focus:border-deep_juniper sm:text-sm" 
     name={id} required>
      {#each options as option (option.id)}
      <option value={option.id} selected={parseInt(option.id) === parseInt(value) ? true : false}>{option.name}</option>
      {/each}
    </select>
    {:else}
    <input id={id} type={type} class="font-body bg-shearling hover:border-deep_juniper appearance-none rounded-none relative block w-full px-3 py-2 border-shearling border border-solid placeholder-gray-400 text-obsidian focus:outline-none focus:ring-deep_juniper focus:border-deep_juniper sm:text-sm" 
     name={id} required={required} autocomplete={id} readonly={readOnly} placeholder={placeholder} value={value} on:input={(evt) => {
       if(callback) callback(evt.target.value)
      }}>
    {/if}
  </fieldset>
</div>